export class ValidationErrorCodes {

  static readonly NumberOutOfRange = 'VALIDATION_ERROR_NUMBER_OUT_OF_RANGE';
  static readonly NumberMustBeGreater = 'VALIDATION_ERROR_NUMBER_MUST_BE_GREATER';
  static readonly NumberMustBeLess = 'VALIDATION_ERROR_NUMBER_MUST_BE_LESS';

  static readonly IsRequired = 'VALIDATION_ERROR_IS_REQUIRED';
  static readonly IsDefined = 'VALIDATION_ERROR_isDefined';

  static readonly EmailNotValid = 'VALIDATION_ERROR_EMAIL_NOT_VALID';
}
